import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global CSS reset + tema-variabler
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  /* ══════ LYST TEMA (standard) ══════ */
  :root, [data-theme="light"] {
    --bg:                 #F7F5FF;
    --bg2:                #EEEAF8;
    --card:               #FFFFFF;
    --card2:              #F7F5FF;
    --txt:                #1A1A35;
    --txm:                #4A4A6A;
    --txl:                #7A7A9A;
    --bdr:                #DDD8F0;
    --accent:             #7C6FF7;
    --accent2:            #5B4FD8;
    --sidebar:            #16162A;
    --sidebar-txt:        #E8E8F8;
    --sidebar-muted:      #6B6B8A;
    --sidebar-active-bg:  rgba(124,111,247,0.18);
    --sidebar-active-txt: #A78BFA;
    --input-bg:           #FFFFFF;
    --input-bdr:          #DDD8F0;
    --input-txt:          #1A1A35;
    --shadow:             0 2px 16px rgba(26,26,46,0.08);
    --green:              #059669;
    --green-bg:           #D1FAE5;
    --red:                #DC2626;
    --red-bg:             #FEE2E2;
    --yellow:             #D97706;
    --yellow-bg:          #FEF3C7;
    --blue:               #2563EB;
    --blue-bg:            #DBEAFE;
  }

  /* ══════ MØRKT TEMA ══════ */
  [data-theme="dark"] {
    --bg:                 #0F0E1A;
    --bg2:                #1A1830;
    --card:               #1E1C32;
    --card2:              #252340;
    --txt:                #F0EFF8;
    --txm:                #C0BEDD;
    --txl:                #8885AA;
    --bdr:                #2E2C48;
    --accent:             #9B8FFF;
    --accent2:            #7C6FF7;
    --sidebar:            #0A0918;
    --sidebar-txt:        #E8E8F8;
    --sidebar-muted:      #8885AA;
    --sidebar-active-bg:  rgba(155,143,255,0.15);
    --sidebar-active-txt: #B8AEFF;
    --input-bg:           #252340;
    --input-bdr:          #3A3860;
    --input-txt:          #F0EFF8;
    --shadow:             0 2px 16px rgba(0,0,0,0.4);
    --green:              #34D399;
    --green-bg:           rgba(52,211,153,0.15);
    --red:                #F87171;
    --red-bg:             rgba(248,113,113,0.15);
    --yellow:             #FBBF24;
    --yellow-bg:          rgba(251,191,36,0.15);
    --blue:               #60A5FA;
    --blue-bg:            rgba(96,165,250,0.15);
  }

  /* ══════ GLOBALE STILER ══════ */
  body {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: var(--bg);
    color: var(--txt);
    transition: background 0.2s, color 0.2s;
  }

  @keyframes spin { to { transform: rotate(360deg); } }

  @keyframes pageIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .page-enter {
    animation: pageIn 0.2s ease-out both;
    height: 100%;
  }

  @keyframes skeletonPulse {
    0%,100% { opacity: 1; }
    50%      { opacity: 0.4; }
  }
  .skeleton-pulse {
    animation: skeletonPulse 1.4s ease-in-out infinite;
    background: #E8E6F0;
    border-radius: 8px;
  }
  [data-theme="dark"] .skeleton-pulse {
    background: #2A2848;
  }

  @keyframes toastIn {
    from { opacity: 0; transform: translateY(-16px) scale(0.96); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes toastOut {
    from { opacity: 1; transform: translateY(0) scale(1); }
    to   { opacity: 0; transform: translateY(-10px) scale(0.96); }
  }

  /* ══════ GLASS-KORT ══════ */
  .glass-card {
    background: rgba(255,255,255,0.82);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255,255,255,0.85);
    box-shadow: 0 4px 24px rgba(124,111,247,0.10), 0 1px 3px rgba(0,0,0,0.04);
    border-radius: 20px;
  }
  [data-theme="dark"] .glass-card {
    background: rgba(30,28,50,0.72);
    border: 1px solid rgba(255,255,255,0.08);
    box-shadow: 0 4px 24px rgba(0,0,0,0.35);
  }

  ::-webkit-scrollbar { width: 5px; }
  ::-webkit-scrollbar-track { background: var(--bg2); }
  ::-webkit-scrollbar-thumb { background: var(--bdr); border-radius: 3px; }

  input, button, select, textarea { font-family: inherit; }

  /* Dark mode: tving input-felter */
  [data-theme="dark"] input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
  [data-theme="dark"] textarea,
  [data-theme="dark"] select {
    background: var(--input-bg) !important;
    color: var(--input-txt) !important;
    border-color: var(--input-bdr) !important;
  }
  [data-theme="dark"] input::placeholder,
  [data-theme="dark"] textarea::placeholder { color: var(--txl) !important; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Registrer service worker for push-varsler og PWA-støtte
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
